module.exports = __webpack_public_path__ + "img/EDI16_L.4a5e4977.png";